import { lighten, styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import Toolbar from '@mui/material/Toolbar';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { selectInterestById, setCreateInterest, fetchInterest } from 'app/store/referralInterestSlice';
import { useEffect, useState } from 'react';
import { setDMUserDialogDetails } from 'app/store/contactsSlice';
import ReferralDetailsPane from "app/shared-components/referral/ReferralDetailsPane";
import {selectOrganizationReferralByOrgAndId} from "app/store/organizationReferralsSlice";


function OrgReferralDetails(props) {
  const dispatch= useDispatch();
  const routeParams = useParams();
  const location = useLocation();
  const {groupId, referralId }= routeParams;
  const navigate= useNavigate();
  const isSearch= location.pathname.includes('/search/');
  const isNotification= location.pathname.includes('/notifications/');
  const orgReferral= useSelector(selectOrganizationReferralByOrgAndId(groupId, referralId));
  const referral= orgReferral?.referral;
  const isClosed = referral?.status && referral.status.startsWith('closed');
  const processInterest= false;
  const interest= processInterest ? useSelector(selectInterestById(referralId)) : null;
  const chatChannelId= interest ? interest.dmChannelId : null;
  const chatUser=interest?.provider;
  const chatTitle= "Referral: " + interest?.summary;

  useEffect(() => {
    //Double check if there is an existing interest
    if (processInterest && referralId && !interest){
       dispatch(fetchInterest({referralId: referralId}));
    }
  }, [referralId, processInterest]);
  
  
  function handleClose(){
	  navigate(-1);
  }
  
  function openInterestDialog() {
	  dispatch(setCreateInterest({...referral, organizationId: groupId}));
  }
  
  function openDMDialog(){
	  dispatch(setDMUserDialogDetails({targetUser: chatUser, title: chatTitle, channelId: chatChannelId}));
  }

  if (!referral) return null;
  
  return (
    <>
      <Box
        className="w-full border-b-1"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? lighten(theme.palette.background.default, 0.4)
              : lighten(theme.palette.background.default, 0.02),
        }}
      >
        <Toolbar className="flex items-center justify-between px-16 w-full">
          <div className="flex items-center flexGrow">
           
           <Typography className="font-semibold text-16">Referral Details</Typography>
          </div>
          <IconButton
              aria-label="Close referral"
              onClick={handleClose}
              className="flex "
              size="large"
            >
              <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
          </IconButton>
        </Toolbar>
      </Box>

      <ReferralDetailsPane
          referral={referral}
          interest={interest}
          enableActions
          openDMDialog={openDMDialog}
          openInterestDialog={openInterestDialog}
      />

    </>
  );
}

export default OrgReferralDetails;
